var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.routerLink)?_c('router-link',{staticClass:"btn-primary",attrs:{"to":_vm.href}},[_c('span',[_vm._t("default")],2)]):_c('a',{staticClass:"btn-primary",attrs:{"href":_vm.href}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }